export const StProcGroup = ({ value, record }) => record.result?.stprocGroup;
